import { BuildingCategories } from './../../models/enum.model';
import { TranslateService } from '@ngx-translate/core';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { LogInComponent } from 'src/app/shared/components/log-in/log-in.component';
import { OperationMode, UserType } from '../../models/enum.model';
import { MunicipalityModel } from '../../models/municipality.model';
import { RegisterUser, SelectAccount } from '../../ngxs/action/account.action';
import { GetBuildingCategories } from '../../ngxs/action/building.action';
import { FilterMunicipalitiesWithoutFiltering } from '../../ngxs/action/municipality.action';
import { AccountState } from '../../ngxs/state/account.state';
import { BuildingState } from '../../ngxs/state/building.state';
import { MunicipalityState } from '../../ngxs/state/municipality.state';
import { LocalizationService } from '../../services/localization.service';
import { NotificationService } from '../../services/notification.service';
import { BuildingCategoryModel } from './../../models/complex-building-category.model';
import { RegisterUserModel } from './../../models/register-user.model';
import { UserModel } from './../../models/user.model';
import { UpdateAccount } from './../../ngxs/action/account.action';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  formGroup: FormGroup;
  closeWindow: boolean;
  subscription = new Subscription();

  @Select(AccountState.isRegistered)
  isRegistered$: Observable<boolean>;

  @Select(MunicipalityState.municipalities)
  municipalities$: Observable<MunicipalityModel[]>;

  @Select(AccountState.selectedAccount)
  selectedAccount$: Observable<UserModel>;

  @Select(BuildingState.categories)
  categories$: Observable<BuildingCategoryModel[]>;

  municipalities: MunicipalityModel[] = [];
  defaultGuid = '00000000-0000-0000-0000-000000000000';

  selectedAllMunicipalities = false;
  selectedAllCategories = false;

  selectedAccount: UserModel;

  categories: BuildingCategoryModel[] = [];

  mode: OperationMode = OperationMode.Create;
  opModes = OperationMode;

  selectedId = '';
  btnLabel = 'register';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<RegisterComponent>,
    private store: Store,
    private formBuilder: FormBuilder,
    private notificationService: NotificationService,
    private localizationService: LocalizationService,
    private translateService: TranslateService
  ) {
    if (data) {
      this.mode = data.mode;

      if (data.id) {
        this.selectedId = data.id;
        this.store.dispatch(new SelectAccount(data.id));
      }
    }

    this.btnLabel = this.mode == OperationMode.Create ? 'register' : 'update';

    this.translateData();
  }

  basicInfoDesc = '';
  coDesc = '';
  co2Desc = '';
  consumpationDesc = '';
  dustDesc = '';
  energyDesc = '';
  geometryDesc = '';
  investmentDesc = '';
  moneySavingDesc = '';
  nmvocDesc = '';
  noxDesc = '';
  pricePerInvestmentDesc = '';
  profitabilityDesc = '';
  rabaArchitectureDesc = '';
  rabaBasicDesc = '';
  rabaManagementDesc = '';
  rabaFunctionalityDesc = '';
  rabaGeometryDesc = '';
  rabaOtherInfoDesc = '';
  so2Desc = '';
  yearlyThermalEnergySavingDesc = '';

  translateData() {
    this.basicInfoDesc = this.localizationService.translate('basic-info');
    this.coDesc = this.localizationService.translate('co');
    this.co2Desc = this.localizationService.translate('co2');
    this.consumpationDesc = this.localizationService.translate('consumpation');
    this.dustDesc = this.localizationService.translate('dust');
    this.energyDesc = this.localizationService.translate('energy');
    this.geometryDesc = this.localizationService.translate('geometry');
    this.investmentDesc = this.localizationService.translate('investment');
    this.moneySavingDesc = this.localizationService.translate('money-saving');
    this.nmvocDesc = this.localizationService.translate('nmvoc');
    this.noxDesc = this.localizationService.translate('nox');
    this.pricePerInvestmentDesc = this.localizationService.translate(
      'price-per-investment'
    );
    this.profitabilityDesc =
      this.localizationService.translate('profitability');
    this.rabaArchitectureDesc =
      this.localizationService.translate('raba-architecture');
    this.rabaBasicDesc = this.localizationService.translate('raba-basic');
    this.rabaManagementDesc =
      this.localizationService.translate('raba-management');
    this.rabaFunctionalityDesc =
      this.localizationService.translate('raba-functionality');
    this.rabaGeometryDesc = this.localizationService.translate('raba-geometry');
    this.rabaOtherInfoDesc =
      this.localizationService.translate('raba-other-info');
    this.so2Desc = this.localizationService.translate('so2');
    this.yearlyThermalEnergySavingDesc = this.localizationService.translate(
      'yearly-thermal-energy-saving'
    );
  }

  getCategoryDescription(name: string) {
    switch (name) {
      case BuildingCategories[BuildingCategories.BasicInfo]:
        return this.basicInfoDesc;
      case BuildingCategories[BuildingCategories.CO]:
        return this.coDesc;
      case BuildingCategories[BuildingCategories.CO2]:
        return this.co2Desc;
      case BuildingCategories[BuildingCategories.Consumation]:
        return this.consumpationDesc;
      case BuildingCategories[BuildingCategories.Dust]:
        return this.dustDesc;
      case BuildingCategories[BuildingCategories.Energy]:
        return this.energyDesc;
      case BuildingCategories[BuildingCategories.Geometry]:
        return this.geometryDesc;
      case BuildingCategories[BuildingCategories.Investment]:
        return this.investmentDesc;
      case BuildingCategories[BuildingCategories.MoneySaving]:
        return this.moneySavingDesc;
      case BuildingCategories[BuildingCategories.NMVOC]:
        return this.nmvocDesc;
      case BuildingCategories[BuildingCategories.Nox]:
        return this.noxDesc;
      case BuildingCategories[BuildingCategories.PricePerInvestment]:
        return this.pricePerInvestmentDesc;
      case BuildingCategories[BuildingCategories.Profitability]:
        return this.profitabilityDesc;
      case BuildingCategories[BuildingCategories.RabaArchitecture]:
        return this.rabaArchitectureDesc;
      case BuildingCategories[BuildingCategories.RabaBasic]:
        return this.rabaBasicDesc;
      case BuildingCategories[BuildingCategories.RabaManagement]:
        return this.rabaManagementDesc;
      case BuildingCategories[BuildingCategories.RabaFunctionality]:
        return this.rabaFunctionalityDesc;
      case BuildingCategories[BuildingCategories.RabaGeometry]:
        return this.rabaGeometryDesc;
      case BuildingCategories[BuildingCategories.RabaOtherInfo]:
        return this.rabaOtherInfoDesc;
      case BuildingCategories[BuildingCategories.SO2]:
        return this.so2Desc;
      case BuildingCategories[
        BuildingCategories.BuildingYearlyTermalEnergySaving
      ]:
        return this.yearlyThermalEnergySavingDesc;
      default:
        return '';
    }
  }

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      email: ['', Validators.email],
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      password: [
        '',
        this.mode == OperationMode.Create
          ? Validators.required
          : Validators.nullValidator,
      ],
      confirmPassword: [
        '',
        this.mode == OperationMode.Create
          ? Validators.required
          : Validators.nullValidator,
      ],
      municipalitiesCtr: [[]],
      categories: [[]],
    });

    this.subscription.add(
      this.municipalities$.subscribe((x) => {
        if (x) {
          this.municipalities = x;
        }
      })
    );

    this.subscription.add(
      this.selectedAccount$.subscribe((x) => {
        if (x) {
          this.selectedAccount = x;
          this.setFormData(this.selectedAccount);
        }
      })
    );

    this.subscription.add(
      this.categories$.subscribe((x) => {
        if (x) {
          this.categories = x;
        }
      })
    );

    this.subscription.add(
      this.translateService.onLangChange.subscribe((x) => {
        if (x) {
          this.translateData();
        }
      })
    );

    this.store.dispatch(
      new FilterMunicipalitiesWithoutFiltering(
        this.translateService.currentLang
      )
    );
    this.store.dispatch(new GetBuildingCategories());
  }

  setFormData(model: UserModel) {
    this.formGroup.controls['email'].setValue(model.email);
    this.formGroup.controls['firstname'].setValue(model.firstname);
    this.formGroup.controls['lastname'].setValue(model.lastname);

    this.formGroup.controls['municipalitiesCtr'].setValue(model.municipalities);
    this.formGroup.controls['categories'].setValue(model.categories);
  }

  selectAllCategories() {
    this.selectedAllCategories = !this.selectedAllCategories;
    if (this.selectedAllCategories) {
      const array = this.categories.map((x) => x.id);
      array.push(this.defaultGuid);

      this.formGroup.controls['categories'].setValue(array);
    } else {
      this.formGroup.controls['categories'].setValue([]);
    }
  }

  selectAllMunicipalities() {
    this.selectedAllMunicipalities = !this.selectedAllMunicipalities;
    if (this.selectedAllMunicipalities) {
      const array = this.municipalities.map((x) => x.id);
      array.push(this.defaultGuid);

      this.formGroup.controls['municipalitiesCtr'].setValue(array);
    } else {
      this.formGroup.controls['municipalitiesCtr'].setValue([]);
    }
  }

  openLogin() {
    this.dialogRef.close();

    this.dialog.open(LogInComponent, {});
  }

  register() {
    if (this.formGroup.valid) {
      const model = new RegisterUserModel();
      model.id = this.selectedId;
      model.email = this.formGroup.controls['email'].value;
      model.firstname = this.formGroup.controls['firstname'].value;
      model.lastname = this.formGroup.controls['lastname'].value;

      model.phoneNumber = ''; //this.formGroup.controls['phoneNumber'].value;
      model.type = UserType.User;

      model.municipalities = this.formGroup.controls['municipalitiesCtr'].value;
      model.categories = this.formGroup.controls['categories'].value;

      // SET email account from logged user
      if (this.mode == OperationMode.Create) {
        model.password = this.formGroup.controls['password'].value;
        model.confirmPassword =
          this.formGroup.controls['confirmPassword'].value;

        if (model.password !== model.confirmPassword) {
          this.notificationService.warning(
            this.localizationService.translate('password-match'),
            this.localizationService.translate('passwords-not-match')
          );
          this.closeWindow = false;
        }
      }

      if (this.mode == OperationMode.Create) {
        if (model.password !== model.confirmPassword) {
          this.notificationService.warning(
            this.localizationService.translate('password-match'),
            this.localizationService.translate('passwords-not-match')
          );
          this.closeWindow = false;
        }

        this.store.dispatch(new RegisterUser(model));
      } else {
        this.store.dispatch(new UpdateAccount(model));
      }

      this.subscription.add(
        this.isRegistered$.subscribe((x) => {
          if (x) {
            this.dialogRef.close();
          }
        })
      );
    } else {
      this.notificationService.warning(
        this.localizationService.translate('error-registration'),
        this.localizationService.translate('populate-all-fields')
      );
    }
  }
}
